<template>
<div>
  <clinic-history></clinic-history>
  <!-- <search-tab></search-tab>
  <help-section></help-section>-->
</div>
  
</template>

<script>
import ClinicHistory from '@/components/shared/ClinicHistory.vue'
import SearchTab from '../../layouts/patient/SearchTab.vue'
import HelpSection from '@/components/video-launcher/HelpSection.vue'

export default {
  components: {
    ClinicHistory,
    SearchTab,
    HelpSection
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/testing/ClinicHistoryTesting.vue